import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { RABBITMQ_PATHS } from './paths';

/** Знак RabbitMQ, контур из Simple Icons (CC0). */
export const RabbitmqIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {RABBITMQ_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
